import axios from 'axios';

// src/index.ts
function defaultResolveErrorMessage(error, fallback) {
  const axiosError = error;
  const status = axiosError.response?.status;
  if (status === 401) return "\u8BA4\u8BC1\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55";
  if (status === 403) return "\u60A8\u6CA1\u6709\u6743\u9650\u6267\u884C\u6B64\u64CD\u4F5C";
  if (status === 404) return "\u8BF7\u6C42\u7684\u8D44\u6E90\u4E0D\u5B58\u5728";
  if (status === 500) return "\u670D\u52A1\u5668\u5185\u90E8\u9519\u8BEF";
  if (status === 502) return "\u7F51\u5173\u9519\u8BEF";
  if (status === 503) return "\u670D\u52A1\u6682\u65F6\u4E0D\u53EF\u7528";
  if (status && status >= 500) return "\u670D\u52A1\u7AEF\u53D1\u751F\u9519\u8BEF";
  if (!status) {
    if (axiosError.code === "ECONNABORTED") return "\u8BF7\u6C42\u8D85\u65F6\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u8FDE\u63A5";
    if (axiosError.code === "ERR_NETWORK") return "\u7F51\u7EDC\u8FDE\u63A5\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC";
    return "\u7F51\u7EDC\u8BF7\u6C42\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5";
  }
  return fallback;
}
function createHttpClient(options) {
  const {
    baseURL,
    timeout,
    withCredentials,
    getToken,
    clearAuth,
    redirectToLogin,
    showError,
    resolveErrorMessage = defaultResolveErrorMessage
  } = options;
  const http = axios.create({
    baseURL,
    timeout,
    withCredentials
  });
  http.interceptors.request.use(
    (config) => {
      const requestConfig = config;
      if (requestConfig.skipAuth) {
        if (requestConfig.headers?.Authorization) {
          delete requestConfig.headers.Authorization;
        }
        return requestConfig;
      }
      const token = getToken?.();
      if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
      }
      return requestConfig;
    },
    (error) => {
      const requestConfig = error.config;
      if (!requestConfig?.suppressErrorToast) {
        showError("\u8BF7\u6C42\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5", { requestConfig, rawError: error });
      }
      return Promise.reject(error);
    }
  );
  http.interceptors.response.use(
    (response) => {
      const { code, message: msg, data } = response.data;
      if (code !== 0) {
        if (code === 401) {
          clearAuth?.();
          redirectToLogin?.();
        }
        const requestConfig = response.config;
        if (!requestConfig.suppressErrorToast) {
          showError(msg || "\u8BF7\u6C42\u5931\u8D25", {
            requestConfig,
            rawError: new Error(msg || "Error")
          });
        }
        return Promise.reject(new Error(msg || "Error"));
      }
      return data;
    },
    (error) => {
      const requestConfig = error.config;
      if (error.response?.status === 401) {
        clearAuth?.();
        redirectToLogin?.();
      }
      const backendMessage = error.response?.data?.message;
      const fallback = backendMessage || error.message || "\u8BF7\u6C42\u5931\u8D25";
      const message = resolveErrorMessage(error, fallback);
      if (!requestConfig?.suppressErrorToast) {
        showError(message, { requestConfig, rawError: error });
      }
      return Promise.reject(error);
    }
  );
  return http;
}

export { createHttpClient };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map